import { forceNewUser } from '../open.helpers';
import { onLoadHandler } from './onLoad';
import { onOpenHandler } from './onOpen';
import { onCloseHandler } from './onClose';
import { onDeinitHandler } from './onDeinit';
import { onLektaContextHandler } from './onLektaContext';
import { onConversationStatusChangedHandler } from './onConversationStatusChanged';
import {
    onUserAuthorizationSuccessHandler,
    onUserAuthorizationFailedHandler
} from './onAuthorization';
import { onMessageSend } from './onMessageSend';
import { onMaintenanceModeEnabledHandler } from './onMaintenanceModeEnabled';
import Logger from '../logger';

const isConversationClosed = ['solved', 'unsolved'].includes(
    window.WC._localStorage.get('conversationStatus')
);

const getInitObject = (args, callbacks, code) => ({
    orgId: window.WC.Closer._closerOrgId,
    enableLog: window.WC.Closer._enableCloserLog,
    forceNewUser: forceNewUser(
        window.WC.Closer.device,
        window.WC.Closer.wasOpen,
        args.authorizationFailed,
        args.contactProcessType,
        window.WC._localStorage.get('userStatus'),
        code
    ),
    ...(isConversationClosed && { disableAutoOpen: true }),
    // initializeBeforeRender: args.pageReload ? true : false,
    onLoad: () => {
        onLoadHandler(args);
    },
    onOpen: () => {
        onOpenHandler(code);
    },
    onClose: () => {
        onCloseHandler(args, callbacks);
    },
    onDeinit: () => {
        onDeinitHandler();
    },
    onLektaContext: (context) => {
        onLektaContextHandler(context);
    },
    ...(code && {
        getLoginHintToken: () => {
            Logger.log('auth init');
            return Promise.resolve('CAAP.' + code);
        }
    }),
    onConversationStatusChanged: ({ status }) => {
        onConversationStatusChangedHandler({ status });
    },
    onUserAuthorizationSuccess: (authorizationResult) => {
        onUserAuthorizationSuccessHandler(args, callbacks, authorizationResult);
    },
    onUserAuthorizationFailed: () => {
        onUserAuthorizationFailedHandler(args, callbacks);
    },
    onMessageSent: () => {
        onMessageSend();
    },
    onMaintenanceModeEnabled: (message) => {
        onMaintenanceModeEnabledHandler(message, callbacks);
    }
});

export { getInitObject };
